import React from "react";
import dynamic from "next/dynamic";
import PaymentDetailsForm from "repoV2/features/CheckoutPages/modules/PaymentDetailsSection/modules/PaymentDetailsForm/PaymentDetailsForm";
import useCheckoutFormRenderState from "../../utils/useCheckoutFormRenderState";
import { checkout_form_types } from "../../constants/CheckoutPages.constants";
import CheckoutShimmer from "../CheckoutShimmer/CheckoutShimmer";

const ExpressInterestForm = dynamic(
    () =>
        import(
            "repoV2/features/CheckoutPages/modules/ExpressInterestSection/modules/ExpressInterestForm/ExpressInterestForm"
        ),
    {
        loading: () => <CheckoutShimmer />,
    }
);

const RenewSubscriptionForm = dynamic(
    () =>
        import(
            "repoV2/features/CheckoutPages/modules/RenewSubscriptionSection/modules/RenewSubscriptionForm/RenewSubscriptionForm"
        ),
    {
        loading: () => <CheckoutShimmer />,
    }
);

const CheckoutFormSectionRender = () => {
    const { formToRender } = useCheckoutFormRenderState();

    switch (formToRender) {
        case checkout_form_types.express_interest_form: {
            return <ExpressInterestForm />;
        }
        case checkout_form_types.payment_form: {
            return <PaymentDetailsForm />;
        }
        case checkout_form_types.renew_subscription_form: {
            return <RenewSubscriptionForm />;
        }
        // Note that this default will ever run, as
        // by default formToRender will always have any above value
        default:
            return <PaymentDetailsForm />;
    }
};

export default CheckoutFormSectionRender;
